var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe"},[_c('iframe',{attrs:{"id":_vm.id,"params":_vm.params,"type":_vm.type,"requestUrl":_vm.requestUrl,"name":"show-iframe","width":"0","height":"0","frameborder":"0","src":_vm.loadingUrl},on:{"load":_vm.finish}})])}
var staticRenderFns = []

export { render, staticRenderFns }